// ----------------Cookie Consent Module------------
const CookieConsentModule = {
  init() {
    console.log('Cookie consent module initialized');
    // Устанавливаем cookie onlyec=false для включения баннера для всех
    document.cookie = "onlyec=false; path=/; expires=" + new Date(Date.now() + 86400000).toUTCString();

    // Запускаем проверку на необходимость показа баннера
    this.checkConsent();
  },

  sendConsentTypeToGTM(consentType) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      'event': 'consentTypeSelected',
      'setReactionType': consentType
    });
  },

  API() {
    return fetch('https://get.geojs.io/v1/ip/geo.json')
      .then((response) => response.json())
      .then((data) => {
        console.log('Geolocation received:', data);
        const euCountries = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'];
        return euCountries.includes(data.country_code);
      })
      .catch((error) => {
        console.error('API Error:', error);
        return false;
      });
  },

  setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + encodeURIComponent(cvalue) + ";" + expires + ";path=/";
  },

  getCookie(name) {
    let matches = document.cookie.match(new RegExp(
      "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  },

  deleteCookie(cname) {
    return new Promise((resolve, reject) => {
      document.cookie = cname + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
      if (document.cookie.indexOf(cname + '=') === -1) {
        resolve('Deleted');
      } else {
        reject('Failed to delete');
      }
    });
  },

  acceptAllCookies() {
    console.log('All cookies accepted');
    this.setCookie('analyticsSwitch', 'true', 365);
    this.setCookie('advertisingSwitch', 'true', 365);
    this.setAllUpdateGoogleParameters();
    this.hideConsentBanner();
  },

  acceptEssentialCookies() {
    console.log('Only essential cookies accepted');
    this.setCookie('analyticsSwitch', 'false', 365);
    this.setCookie('advertisingSwitch', 'false', 365);
    this.setOnlyEssentialGoogleParameters();
    this.hideConsentBanner();
  },

  setAllUpdateGoogleParameters() {
    this.sendConsentTypeToGTM('All');
    this.setCookie("setTypeAccept", "All", 365);
    this.setCookie("acceptBanner", "accepted", 365);
  },

  setOnlyEssentialGoogleParameters() {
    this.sendConsentTypeToGTM('Essential');
    this.setCookie("setTypeAccept", "Essential", 365);
    this.setCookie("acceptBanner", "accepted", 365);
  },

  setCustomizeGoogleParameters() {
    var analyticsSwitch = document.getElementById('analyticsSwitch').checked;
    var advertisingSwitch = document.getElementById('advertisingSwitch').checked;

    this.setCookie('analyticsSwitch', analyticsSwitch.toString(), 365);
    this.setCookie('advertisingSwitch', advertisingSwitch.toString(), 365);

    if (analyticsSwitch && advertisingSwitch) {
      this.sendConsentTypeToGTM('All');
      this.setCookie("setTypeAccept", "All", 365);
    } else if (analyticsSwitch && !advertisingSwitch) {
      this.sendConsentTypeToGTM('Analytics');
      this.setCookie("setTypeAccept", "Analytics", 365);
    } else if (!analyticsSwitch && advertisingSwitch) {
      this.sendConsentTypeToGTM('Advertising');
      this.setCookie("setTypeAccept", "Advertising", 365);
    } else if (!analyticsSwitch && !advertisingSwitch) {
      this.sendConsentTypeToGTM('Essential');
      this.setCookie("setTypeAccept", "Essential", 365);
    }

    this.setCookie("acceptBanner", "accepted", 365);
  },

  // --- ФУНКЦИИ ОТОБРАЖЕНИЯ (ОЧИЩЕННЫЕ ОТ HTML) ---

  customizeCookies() {
    var analyticsSwitchCookie = this.getCookie('analyticsSwitch');
    var advertisingSwitchCookie = this.getCookie('advertisingSwitch');

    var analyticsSwitchChecked = (analyticsSwitchCookie === 'true');
    var advertisingSwitchChecked = (advertisingSwitchCookie === 'true');

    var analyticsCheckbox = document.getElementById('analyticsSwitch');
    var advertisingCheckbox = document.getElementById('advertisingSwitch');
    
    if (analyticsCheckbox) analyticsCheckbox.checked = analyticsSwitchChecked;
    if (advertisingCheckbox) advertisingCheckbox.checked = advertisingSwitchChecked;

    // Скрываем главный вид, показываем настройки
    document.getElementById('cookieViewMain').style.display = 'none';
    document.getElementById('cookieViewCustomize').style.display = 'block';
  },

  showInitialConsent() {
    // Показываем главный контейнер всего баннера
    var container = document.getElementById('cookieConsentContainer');
    if (container) container.style.display = 'block';

    // Показываем главный вид, скрываем настройки (если вернулись кнопкой Back)
    var viewMain = document.getElementById('cookieViewMain');
    var viewCustomize = document.getElementById('cookieViewCustomize');
    
    if (viewMain) viewMain.style.display = 'block';
    if (viewCustomize) viewCustomize.style.display = 'none';
  },

  showMiniBannerAfterAcceptedCookies() {
    var miniBanner = document.getElementById('cookieConsentContainerMini');
    if (miniBanner) {
      miniBanner.style.display = 'block';
    }

    window.showInitialConsentBig = function () {
      if (miniBanner) {
        miniBanner.style.display = 'none';
      }
      CookieConsentModule.showInitialConsent();
    };
  },

  hideConsentBanner() {
    var consentBanner = document.getElementById('cookieConsentContainer');
    if (consentBanner) {
      consentBanner.style.display = 'none';
    }
    this.showMiniBannerAfterAcceptedCookies();
  },

  saveAndApply() {
    console.log('Save and apply settings');
    this.setCustomizeGoogleParameters();
    this.hideConsentBanner();
  },

  ifPeopleFromEC() {
    console.log('User from EU - showing banner');
    this.setCookie("setTypeAccept", "UserEC", 365);
    this.setCookie("setWithGeo", "UserEC", 365);
    this.showInitialConsent();
  },

  ifPeopleDontFromEC() {
    console.log('User not from EU - not showing banner');
    this.sendConsentTypeToGTM('UserDontEC');
    this.setCookie("setTypeAccept", "UserDontEC", 365);
    this.setCookie("acceptBanner", "accepted", 365);
    this.setCookie("setWithGeo", "UserDontEC", 365);
  },

  checkConsent() {
    const onlyec = this.getCookie('onlyec');
    const acceptBanner = this.getCookie('acceptBanner');
    console.log(`[Cookie Consent] Статус: onlyec=${onlyec}, acceptBanner=${acceptBanner}`);

    if (acceptBanner === 'accepted') {
      console.log('[Cookie Consent] Согласие уже дано, показываем мини-баннер.');
      this.showMiniBannerAfterAcceptedCookies();
      return; 
    }

    if (onlyec === 'false') {
      console.log('[Cookie Consent] Режим "Показывать всем" активен. Показываем баннер.');
      this.showInitialConsent(); // Просто вызываем показ (без document.createElement)
      return; 
    }

    console.log('[Cookie Consent] Режим "Только для ЕС". Запускаем API геолокации...');
    this.API().then((isEC) => {
      const currentAcceptBanner = this.getCookie('acceptBanner');
      if (currentAcceptBanner === 'accepted') {
        this.showMiniBannerAfterAcceptedCookies();
        return;
      }

      const setTypeAccept = this.getCookie('setTypeAccept');
      if ((setTypeAccept === "UserDontEC") && isEC) {
        this.deleteCookie("setTypeAccept")
          .then(() => this.deleteCookie("acceptBanner"))
          .then(() => {
            console.log('[Cookie Consent] Cookies удалены для перехода от неЕС в ЕС');
            this.ifPeopleFromEC(); 
          })
          .catch((error) => {
            this.ifPeopleFromEC(); 
          });
        return;
      }

      if (isEC) {
        this.ifPeopleFromEC(); 
      } else {
        this.ifPeopleDontFromEC(); 
      }
    }).catch(apiError => {
      console.error('[Cookie Consent] Ошибка API геолокации:', apiError);
      const currentAcceptBanner = this.getCookie('acceptBanner');
      if (currentAcceptBanner === 'accepted') {
        this.showMiniBannerAfterAcceptedCookies();
      } else {
        this.ifPeopleFromEC(); 
      }
    });
  }
};

window.CookieConsentModule = CookieConsentModule;
// ----------------Cookie Consent Module END------------


// ----------------Burger menu------------
const MenuModule = {
  init() {
    this.burgerMenu = document.getElementById('burgerMenu');
    this.headerMenu = document.getElementById('headerMenu');
    this.menuLinks = document.querySelectorAll('.header__link');

    if (this.burgerMenu && this.headerMenu) {
      this.bindEvents();
    }
  },

  bindEvents() {
    this.burgerMenu.addEventListener('click', () => this.toggleMenu());
    this.menuLinks.forEach(link => {
      link.addEventListener('click', () => this.closeMenu());
    });
  },

  toggleMenu() {
    this.burgerMenu.classList.toggle('burger__active');
    this.headerMenu.classList.toggle('burger__active');
  },

  closeMenu() {
    this.burgerMenu.classList.remove('burger__active');
    this.headerMenu.classList.remove('burger__active');
  }
};
// ----------------END--------------------

// ----------------Gallery Module------------
const GalleryModule = {
  init() {
    // Проверяем, есть ли на странице элементы для галереи
    if (document.querySelector('.glightbox')) {
      const lightbox = GLightbox({
        touchNavigation: true, // Включаем свайпы на телефоне
        loop: true,            // Бесконечная прокрутка
        zoomable: true         // Разрешаем зумить картинку
      });      

      console.log('GLightbox initialized');
    }
  }
};
// ----------------END--------------------

// Инициализация при загрузке DOM
document.addEventListener('DOMContentLoaded', () => {
  MenuModule.init();
  CookieConsentModule.init();
  GalleryModule.init();
});
